import React, { ReactElement } from 'react';

import { Icon } from '@iconify/react';

import router from '~/core/router';
import { settingsSidebar } from '~/core/sidebar';
import {
  PersonalInformationRoute,
  SecurityRoute,
  SubscriptionRoute,
} from '~/modules/settings';

router.addPrivateRoutes([
  PersonalInformationRoute,
  SecurityRoute,
  SubscriptionRoute,
]);

// TODO! Localization. Check other sidebar elements as well
settingsSidebar.addItems({
  a: [
    {
      key: 'personal_information',
      path: PersonalInformationRoute.path,
      getTitle: PersonalInformationRoute.getTitle,
      Icon: (props): ReactElement => (
        <Icon {...props} icon="material-symbols:person-outline" />
      ),
    },
    {
      key: 'security',
      path: SecurityRoute.path,
      getTitle: SecurityRoute.getTitle,
      Icon: (props): ReactElement => (
        <Icon {...props} icon="material-symbols:key-outline" />
      ),
    },
    {
      key: 'subscription',
      path: SubscriptionRoute.path,
      getTitle: SubscriptionRoute.getTitle,
      Icon: (props): ReactElement => (
        <Icon {...props} icon="material-symbols:card-membership-outline" />
      ),
    },
  ],
});
